// extracted by mini-css-extract-plugin
export default {"menuBlock":"kG-z","title":"lG-z","nav":"mG-z","flexCell":"nG-z","facetLink":"oG-z"};